/**                                          
   * Casati Milano Booking Form                                                         
   * External JavaScript - Shopify cannot format this                                      
   */
                                                                                           
  (function() {                    
    const API_BASE = 'https://milanostraps-ai.vercel.app';                                 
    const form = document.getElementById('bookingForm');                                   
    const submitBtn = document.getElementById('submitBtn');
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    const slotSelect = document.getElementById('appointmentSlot');
    const loadingSlots = document.getElementById('loadingSlots');

    // Le stringhe arrivano dal template già tradotte (filtro `t`): questo file è
    // statico, Shopify non lo passa da Liquid. I valori qui sotto sono solo il
    // ricambio se il blocco JSON manca — non sono la lingua della pagina.
    const I18N = (() => {
      try { return JSON.parse(document.getElementById('casatiBookingI18n').textContent); }
      catch { return {}; }
    })();

    const LANG = I18N.lang || document.documentElement.lang || 'it';

    const MESSAGES = {
      noSlots: I18N.slotsNone || 'Nessuna disponibilità al momento. Ci contatti direttamente.',
      loadError: I18N.slotsError || 'Non è stato possibile caricare le disponibilità. Ricarichi la pagina.',
      bookingError: I18N.bookingError || 'Si è verificato un errore. Riprovi o ci contatti direttamente.',
      submitting: I18N.submitting || 'Invio in corso…',
      submitLabel: I18N.submitLabel || 'Conferma la prenotazione',
      rescheduleSubmit: I18N.rescheduleSubmit || 'Conferma il nuovo orario',
      rescheduleHint: I18N.rescheduleHint || 'Sta spostando il Suo appuntamento: scelga solo il nuovo orario, ai dati pensiamo noi.',
      errPhone: I18N.errPhone || 'Controlli il numero: manca qualcosa.'
    };

    // MODALITÀ SPOSTAMENTO (2026-08-27): il link nel WhatsApp "Cambio orario"
    // arriva con ?sposta=<id>&exp=<epoch>&t=<firma>. La pagina nasconde il form
    // (nome, email, telefono, note): il cliente sceglie SOLO il nuovo orario e
    // l'API sposta la prenotazione esistente — nessun dato da ricompilare.
    const QP = new URLSearchParams(window.location.search);
    const RESCHEDULE = (QP.get('sposta') && QP.get('exp') && QP.get('t'))
      ? { id: QP.get('sposta'), exp: QP.get('exp'), token: QP.get('t') }
      : null;

    if (RESCHEDULE) {
      ['customerName', 'email', 'phone', 'notes', 'marketingOptin'].forEach(function(id) {
        const el = document.getElementById(id);
        if (!el) return;
        el.required = false;
        const group = el.closest('.form-group');
        if (group) group.style.display = 'none';
      });
      submitBtn.textContent = MESSAGES.rescheduleSubmit;
      const hint = document.createElement('p');
      hint.className = 'reschedule-hint';
      hint.textContent = MESSAGES.rescheduleHint;
      form.insertBefore(hint, form.firstChild);
    }

    // ── DOVE: atelier o videochiamata (2/09/2026) ──────────────────────────
    // ?modalita=videochiamata (dai link del bot e della pagina videochiamata
    // di casatimilano.com) preseleziona il radio; in spostamento il gruppo
    // sparisce come gli altri dati già noti.
    if (QP.get('modalita') === 'videochiamata') {
      const radioVideo = document.querySelector('input[name="luogo"][value="videochiamata"]');
      if (radioVideo) radioVideo.checked = true;
    }
    if (RESCHEDULE) {
      const luogoGroup = document.querySelector('.luogo-group');
      if (luogoGroup) luogoGroup.style.display = 'none';
    }

    // ── PREFISSO INTERNAZIONALE ─────────────────────────────────────────────
    // Il placeholder col prefisso non bastava: sparisce appena si scrive, e su
    // /en mostrava un esempio britannico a un cliente americano, che ha
    // prenotato lasciando "5126260512". Twilio non consegna a un numero senza
    // prefisso: niente conferma, niente promemoria, nessun errore (31/08).
    //
    // Il paese di partenza, in ordine: la REGIONE del browser (navigator.language
    // dice "en-US", non "en" — è la persona a dichiararla, ed è l'indizio più
    // preciso che abbiamo), poi il paese scelto col selettore di mercato, poi
    // l'Italia.
    //
    // La libreria arriva `defer`: qui si è dentro DOMContentLoaded, che scatta
    // DOPO. Se manca o fallisce, il campo resta quello di prima e il form
    // funziona lo stesso — la rete di sicurezza vera è comunque lato server.
    let ITI = null;

    // Fuso orario → paese. Non è un elenco completo del mondo: sono l'Europa
    // (il nostro mercato) e le piazze da cui arrivano collezionisti. Fuori da
    // qui si ripiega sulla regione del browser, che è meno precisa ma c'è
    // sempre.
    const PAESE_DA_FUSO = {
      'Europe/Rome': 'IT', 'Europe/Vatican': 'IT', 'Europe/San_Marino': 'IT',
      'Europe/Berlin': 'DE', 'Europe/Busingen': 'DE', 'Europe/Vienna': 'AT',
      'Europe/Zurich': 'CH', 'Europe/Paris': 'FR', 'Europe/Monaco': 'MC',
      'Europe/Madrid': 'ES', 'Africa/Ceuta': 'ES', 'Atlantic/Canary': 'ES',
      'Europe/Lisbon': 'PT', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
      'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Luxembourg': 'LU',
      'Europe/Copenhagen': 'DK', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO',
      'Europe/Helsinki': 'FI', 'Europe/Warsaw': 'PL', 'Europe/Prague': 'CZ',
      'Europe/Bratislava': 'SK', 'Europe/Budapest': 'HU', 'Europe/Ljubljana': 'SI',
      'Europe/Zagreb': 'HR', 'Europe/Bucharest': 'RO', 'Europe/Sofia': 'BG',
      'Europe/Athens': 'GR', 'Europe/Nicosia': 'CY', 'Europe/Malta': 'MT',
      'Europe/Tallinn': 'EE', 'Europe/Riga': 'LV', 'Europe/Vilnius': 'LT',
      'Europe/Istanbul': 'TR', 'Europe/Moscow': 'RU', 'Europe/Kyiv': 'UA',
      'America/New_York': 'US', 'America/Detroit': 'US', 'America/Chicago': 'US',
      'America/Denver': 'US', 'America/Phoenix': 'US', 'America/Los_Angeles': 'US',
      'America/Anchorage': 'US', 'Pacific/Honolulu': 'US',
      'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Edmonton': 'CA',
      'America/Mexico_City': 'MX', 'America/Sao_Paulo': 'BR',
      'America/Argentina/Buenos_Aires': 'AR', 'America/Santiago': 'CL',
      'Asia/Dubai': 'AE', 'Asia/Qatar': 'QA', 'Asia/Riyadh': 'SA',
      'Asia/Hong_Kong': 'HK', 'Asia/Singapore': 'SG', 'Asia/Tokyo': 'JP',
      'Asia/Seoul': 'KR', 'Asia/Shanghai': 'CN', 'Asia/Taipei': 'TW',
      'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ'
    };

    /**
     * Dove SI TROVA il cliente, non che lingua legge.
     *
     * Il fuso orario viene prima di tutto: misurato su questa stessa pagina,
     * un browser diceva lingua "en-US" e fuso "Europe/Rome" — la persona era
     * in Italia con l'interfaccia in inglese. Fidandosi della lingua le
     * avremmo proposto +1. Per un appuntamento in Via XX Settembre, il posto
     * in cui uno si trova conta più della lingua che ha scelto.
     */
    function paeseIniziale() {
      try {
        const fuso = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (PAESE_DA_FUSO[fuso]) return PAESE_DA_FUSO[fuso];
      } catch (e) { /* browser senza Intl completo: si tira avanti */ }

      const regione = (navigator.languages || [navigator.language || ''])
        .map(function(l) { return String(l).split('-')[1]; })
        .filter(Boolean)[0];
      return (regione || I18N.shopCountry || 'IT').toUpperCase();
    }

    document.addEventListener('DOMContentLoaded', function() {
      const campo = document.getElementById('phone');
      if (!campo || RESCHEDULE || typeof window.intlTelInput !== 'function') return;
      try {
        ITI = window.intlTelInput(campo, {
          initialCountry: paeseIniziale(),
          countryOrder: ['it', 'de', 'fr', 'es', 'gb', 'us', 'ch', 'at'],
          separateDialCode: true,
          // Il segnaposto lo scrive la libreria, con un numero d'esempio del
          // paese scelto e SENZA prefisso — quello è già nel campo accanto.
          // AGGRESSIVE perché il nostro (tradotto, col prefisso dentro) c'è
          // già e altrimenti resterebbe: ripeterebbe il prefisso e, su /en,
          // mostrerebbe un esempio britannico a un americano.
          // ⚠️ Nella v29 l'opzione NON si chiama più `autoPlaceholder`: col
          // vecchio nome la libreria stampa "Unknown option" in console e tira
          // dritto — nessun errore, nessun effetto.
          placeholderNumberPolicy: 'AGGRESSIVE',
          // I nomi dei paesi nella lingua della pagina (Germania/Deutschland/
          // Allemagne), non in inglese per tutti.
          countryNameLocale: LANG,
          // Il numero parte in E.164 (+15126260512): è il formato che vuole
          // Twilio, ed è quello che il server si aspetta di non dover indovinare.
          formatAsYouType: true,
          uiTranslations: {
            searchPlaceholder: I18N.phoneSearch || 'Cerchi il Paese',
            selectedCountryAriaLabel: I18N.phoneCountry || 'Paese del numero',
            countryListAriaLabel: I18N.phoneCountry || 'Paese del numero',
            noCountrySelected: I18N.phoneCountry || 'Paese del numero',
            searchEmptyState: I18N.phoneNoResults || 'Nessun Paese trovato'
          }
        });
        // L'errore non urla mentre si scrive: si spegne appena si corregge.
        campo.addEventListener('input', function() { campo.classList.remove('is-invalid'); });
      } catch (e) {
        console.warn('[booking] selettore prefisso non attivo:', e);
        ITI = null;
      }
    });

    /**
     * Etichetta dell'appuntamento nella lingua della pagina.
     * L'API restituisce `label` con giorno e mese scritti in italiano per tutti
     * (lib/google-calendar/calendar-client.js), quindi la data la componiamo qui
     * con Intl: nessuna tabella di nomi di giorni da mantenere in cinque lingue.
     * Se il record non porta una data valida si ripiega sull'etichetta dell'API.
     */
    function etichettaSlot(slot) {
      const d = new Date(slot.value || slot.datetime);
      if (isNaN(d)) return slot.label || '';
      const giorno = new Intl.DateTimeFormat(LANG, {
        weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/Rome'
      }).format(d);
      const ora = new Intl.DateTimeFormat(LANG, {
        hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Rome'
      }).format(d);
      let etichetta = `${giorno.charAt(0).toUpperCase()}${giorno.slice(1)} · ${ora}`;
      // 3/09/2026: gli orari sono di Milano, ma chi legge può essere ovunque —
      // un cliente in Virginia ha prenotato le 07:00 credendole le sue (era
      // l'1 di notte). Se il fuso del browser non è quello di Milano, ogni
      // slot mostra anche l'ora locale del cliente; con il giorno, se cambia.
      try {
        const tzUtente = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (tzUtente && tzUtente !== 'Europe/Rome') {
          const oraLocale = new Intl.DateTimeFormat(LANG, {
            hour: '2-digit', minute: '2-digit', hour12: false, timeZone: tzUtente
          }).format(d);
          if (oraLocale !== ora) {
            const giornoMilano = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
            const giornoUtente = new Intl.DateTimeFormat('en-CA', { timeZone: tzUtente, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
            const prefissoGiorno = giornoMilano !== giornoUtente
              ? new Intl.DateTimeFormat(LANG, { weekday: 'short', timeZone: tzUtente }).format(d) + ' '
              : '';
            etichetta += ` (${I18N.tzYours || 'your time:'} ${prefissoGiorno}${oraLocale})`;
          }
        }
      } catch (e) { /* browser senza fuso risolvibile: l'etichetta resta di Milano */ }
      return etichetta;
    }

    // Load available time slots on page load
    async function loadAvailableSlots() {
      try {
        const response = await fetch(`${API_BASE}/api/casati-booking`);
        const data = await response.json();

        if (data.success && data.slots && data.slots.length > 0) {
          // Populate select with available slots
          data.slots.forEach(slot => {
            const option = document.createElement('option');
            option.value = slot.value;
            option.textContent = etichettaSlot(slot);
            slotSelect.appendChild(option);
          });

          loadingSlots.style.display = 'none';
          slotSelect.style.display = 'block';
        } else {
          loadingSlots.textContent = MESSAGES.noSlots;
        }
      } catch (error) {
        console.error('Error loading slots:', error);
        loadingSlots.textContent = MESSAGES.loadError;
      }
    }

    // Handle form submission
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      // Hide previous messages
      successMsg.style.display = 'none';
      errorMsg.style.display = 'none';

      // Il numero si controlla PRIMA di bloccare il bottone: se è incompleto il
      // cliente deve poter correggere subito, non dopo un giro sul server.
      //
      // ⚠️ isValidNumberPrecise(), NON isValidNumber(). Sono due cose diverse e
      // il nome non lo lascia capire: isValidNumber() guarda solo se la
      // LUNGHEZZA è possibile per quel paese — misurato, "151 234" su numero
      // tedesco passa. isValidNumberPrecise() controlla che quel numero esista
      // davvero nei blocchi assegnati, e lo respinge.
      // Qui serve il secondo: un numero "di lunghezza plausibile" ma
      // inesistente è esattamente il caso che ci ha fregati — nessun errore
      // oggi, nessuna consegna domani.
      const campoTel = document.getElementById('phone');
      if (!RESCHEDULE && ITI && campoTel && !ITI.isValidNumberPrecise()) {
        campoTel.classList.add('is-invalid');
        errorMsg.textContent = MESSAGES.errPhone;
        errorMsg.style.display = 'block';
        campoTel.focus();
        return;
      }

      // Disable submit button
      submitBtn.disabled = true;
      submitBtn.textContent = MESSAGES.submitting;

      // Collect form data — in modalità spostamento viaggiano solo id firmato
      // e nuovo orario: i dati del cliente li ha già la prenotazione.
      const formData = RESCHEDULE
        ? {
            rescheduleId: RESCHEDULE.id,
            exp: RESCHEDULE.exp,
            token: RESCHEDULE.token,
            datetime: document.getElementById('appointmentSlot').value
          }
        : {
            customerName: document.getElementById('customerName').value,
        // 2026-09-08: da dove arriva chi prenota (primo atterraggio della sessione, se il layout lo ha salvato)
        referrer: (function(){ try { return sessionStorage.getItem('ms_referrer') || document.referrer || ''; } catch (e) { return document.referrer || ''; } })(),
        landing: (function(){ try { return sessionStorage.getItem('ms_landing') || location.href; } catch (e) { return location.href; } })(),
            customerEmail: document.getElementById('email').value,
            // E.164 dal selettore (+15126260512). Senza libreria si manda il
            // grezzo e la normalizzazione lato server fa da rete.
            customerPhone: ITI ? ITI.getNumber() : document.getElementById('phone').value,
            datetime: document.getElementById('appointmentSlot').value,
            // Il prefisso [VIDEOCHIAMATA]/[IN ATELIER] è la convenzione che il
            // server riconosce (stessa del modulo casatimilano.com): decide
            // quale conferma parte — con indirizzo o con la sala Meet.
            notes: (function () {
              const scelto = document.querySelector('input[name="luogo"]:checked');
              const prefisso = (scelto && scelto.value === 'videochiamata') ? '[VIDEOCHIAMATA] ' : '[IN ATELIER] ';
              return prefisso + (document.getElementById('notes').value || '');
            })(),
            // La lingua della pagina viaggia con la prenotazione: conferma,
            // reminder e conferma del giorno la usano. Senza, partivano tutti
            // in italiano anche a chi aveva prenotato dalla pagina tedesca.
            lang: LANG,
            marketingOptin: !!document.getElementById('marketingOptin')?.checked,
            watchInfo: {
              brand: 'Da specificare',
              model: 'Da specificare'
            }
          };

      try {
        const response = await fetch(`${API_BASE}/api/casati-booking`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (result.success) {
          // Show success message
          successMsg.style.display = 'block';
          form.reset();

          // Scroll to success message
          successMsg.scrollIntoView({ behavior: 'smooth' });

          // Reload slots (booked slot will be removed)
          setTimeout(() => {
            loadAvailableSlots();
          }, 2000);
        } else {
          throw new Error(result.error || 'Errore durante la prenotazione');
        }
      } catch (error) {
        console.error('Booking error:', error);
        errorMsg.textContent = `⚠️  ${error.message || MESSAGES.bookingError}`;
        errorMsg.style.display = 'block';
        // a11y (2026-08-17): gli agenti e gli screen reader leggono aria-invalid, non
        // il colore del bordo. Marchiamo i campi obbligatori vuoti/non validi e li
        // ripuliamo appena l'utente li corregge.
        form.querySelectorAll('[required]').forEach((el) => {
          const ko = !el.checkValidity();
          el.setAttribute('aria-invalid', ko ? 'true' : 'false');
          if (ko && !el.dataset.a11yBound) {
            el.dataset.a11yBound = '1';
            el.addEventListener('input', () => { if (el.checkValidity()) el.setAttribute('aria-invalid', 'false'); });
          }
        });
        errorMsg.scrollIntoView({ behavior: 'smooth' });
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = RESCHEDULE ? MESSAGES.rescheduleSubmit : MESSAGES.submitLabel;
      }
    });

    // Load slots on page load
    loadAvailableSlots();
  })();